import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

interface IValueProp {
  title: string;
  description: string;
  iconUrl: string;
  darkIconUrl?: string;
}

interface ILink {
  displayText: string;
  url: string;
  leadingIcon: string;
  trailingIcon: string;
  darkLeadingIcon?: string;
  darkTrailingIcon?: string;
}

interface IConfig {
  assetUrl: string;
  darkAssetUrl?: string;
  titleText: string;
  description: string;
  valuePropositions: IValueProp[];
  link: ILink;
}

@Component({
  selector: 'walk-guidance-webview',
  templateUrl: './walk-guidance-webview.component.html',
  styleUrls: ['./walk-guidance-webview.component.css']
})
export class WalkGuidanceWebviewComponent implements OnInit {

  place: string;
  hasVpIcons = false;
  walkGuidanceConfig: any;
  error = false;
  configuration: IConfig;
  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.error = false;
    try {
      this.walkGuidanceConfig = environment.walkGuidanceConfig;
      this.route.queryParams.subscribe(params => {
        if (params) {
          this.place = params.placeName || "";
          if (this.place && this.walkGuidanceConfig && this.walkGuidanceConfig[this.place]) {
            this.configuration = this.walkGuidanceConfig[this.place];
          } else {
            this.error = true;
            return;
          }
        } else {
          this.error = true;
          return;
        }
      })

      this.checkIcons();

    } catch (e) {
      this.error = true;
    }
  }

  checkIcons() {
    if (this.configuration && this.configuration.valuePropositions && this.configuration.valuePropositions.length) {
      this.hasVpIcons = true;
      for (let proposition of this.configuration.valuePropositions) {
        if (!proposition.iconUrl || proposition.iconUrl == "") {
          this.hasVpIcons = false;
          break;
        }
      }
    }
  }

  renderTitle(title) {
    var newText = title.replace(/\n/g, "<br>");
    return newText;
  }
}
